import { collection, query, where, getDocs, addDoc, serverTimestamp, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export const createChatRoom = async (userId1, userId2, propertyData = null, skipGenderCheck = false) => {
    try {
        // 入力値の検証
        if (!userId1 || !userId2) {
            throw new Error('ユーザーIDが無効です');
        }

        // 性別チェック（スキップオプションがある場合は実行しない）
        if (!skipGenderCheck) {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`/api/users/check-gender-compatibility`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ targetUserId: userId2 })
                });

                if (!response.ok) {
                    // 403エラーは想定内の動作
                    const error = await response.json();
                    throw new Error(error.message || '連絡できません');
                }
            } catch (error) {
                // エラーメッセージがある場合はそのままスロー、それ以外はコンソールに出力
                if (error.message && error.message !== '連絡できません') {
                    throw error;
                }
                // ネットワークエラーなど予期せぬエラーの場合のみログを出力
                if (!(error instanceof Error && error.message)) {
                    console.error('性別互換性チェックエラー:', error);
                }
                throw error;
            }
        }

        // チャットルームの存在確認
        const chatRoomsRef = collection(db, 'chatRooms');
        const q = query(
            chatRoomsRef,
            where('participants', 'array-contains', userId1)
        );

        const querySnapshot = await getDocs(q);
        const existingRoom = querySnapshot.docs.find(doc =>
            doc.data().participants.includes(userId2)
        );

        if (existingRoom) {
            // 既存のチャットルームが物件問い合わせ用で、新しい問い合わせが通常チャットの場合は
            // 新しいチャットルームを作成する
            const existingData = existingRoom.data();
            if (existingData.type === 'ROOM_INQUIRY' && !propertyData) {
                // 新しいチャットルームを作成
            } else {
                return existingRoom.id;
            }
        }

        // チャットルームのデータを作成
        const chatRoomData = {
            participants: [userId1, userId2],
            createdAt: serverTimestamp(),
            lastMessage: '',
            lastMessageTime: serverTimestamp(),
            updatedAt: serverTimestamp()
        };

        // 物件からの問い合わせの場合
        if (propertyData) {
            chatRoomData.type = 'ROOM_INQUIRY';
            chatRoomData.locationInfo = {
                city: propertyData.city,
                roomId: propertyData.roomId
            };
        }

        const newRoomRef = await addDoc(chatRoomsRef, chatRoomData);
        return newRoomRef.id;

    } catch (error) {
        console.error('チャットルーム作成エラー:', error);
        throw new Error('チャットルームの作成に失敗しました');
    }
};

export const sendMessage = async (roomId, userId, message) => {
    try {
        if (!roomId || !userId || !message.trim()) {
            throw new Error('無効なパラメータです');
        }

        const messageData = {
            text: message.trim(),
            senderId: userId,
            createdAt: serverTimestamp(),
            read: false
        };

        const messagesRef = collection(db, 'chatRooms', roomId, 'messages');
        await addDoc(messagesRef, messageData);

        // 最後のメッセージを更新
        const roomRef = doc(db, 'chatRooms', roomId);
        await updateDoc(roomRef, {
            lastMessage: message.trim(),
            lastMessageTime: serverTimestamp(),
            lastMessageSenderId: userId,
            updatedAt: serverTimestamp()
        });
    } catch (error) {
        console.error('メッセージ送信エラー:', error);
        throw new Error('メッセージの送信に失敗しました');
    }
}; 